module.exports = __webpack_public_path__ + "img/medium.4969e48d.png";